import { useState, useRef } from "react"
import { useDispatch } from "react-redux"
import { Form, Row, Col, ProgressBar, Stack } from "react-bootstrap"
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling'
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { TextButton } from 'Components/Button';
import FileList from "Components/FileList/FileList";
import { ERROR_MESSAGES } from "Utils/constants"

const AltFileUpload = ({
  initData,
  isTestSubmission,
  submitFile,
  fileFormat,
  refreshDataTable,
  progress,
  setProgress
}) => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  /**
   * {
   * 
   *  isTestSubmission: isTestSubmission,
      cfVersionId: e.target.value,
      //mandatory for vendor, N/A (null) for PSO. the value is the organization this vendor is submitting the CDA data 
      //for. e.g. the vendor "Vendor1"(id: 12345) is submitting CDA data for PSO "Org2"(id:12121), the value is 12121. 
      organizationId: 
   * 
   * }
   */
  const [modelJson, setModelJson] = useState({});
  const [isInvalid, setIsInvalid] = useState(false);
  const fileInputRef = useRef();
  const cfSelectRef = useRef();
  const psoSelectRef = useRef();

  // validationMsg before send it to the java backend: 
  // {
  //    "cfVersionId": {
  //             inValid: true/false
  //             msg: []
  //           },
  //     "files": {
  //             inValid: true/false
  //             msg: []
  //           }
  // }
  const [validationMsg, setValidationMsg] = useState({});

  const handleFilesChange = (e) => {
    setIsInvalid(false);
    setProgress(null);
    let validation = {};

    if (validationMsg.cfVersionId) {
      validation = { "cfVersionId": validationMsg.cfVersionId };
    }

    if (validationMsg.organizationId) {
      validation = {
        ...validation,
        "organizationId": validationMsg.organizationId
      };
    }

    let uploaded = [];

    if (files) {
      uploaded = [...files];
    }

    if (e.target.files) {
      const chosenFiles = Array.prototype.slice.call(e.target.files)
      chosenFiles.map(file => {

        if (uploaded.findIndex((f) => f.name === file.name) === -1) {
          uploaded.push(file);
        } else {
          let arrFilesMsg = [];
          arrFilesMsg.push("Duplicate file: " + file.name);
          validation = {
            ...validation,
            "files": {
              inValid: true,
              msg: arrFilesMsg
            }
          };
        }
      })
      setFiles(uploaded);
      setValidationMsg(validation);
      fileInputRef.current.value = "";
    }
  }

  const submitFiles = async (formData, validation) => {
    return await submitFile(formData).then((res) => {
      //console.log("submitFile()", res, res.status);
      if (res.status != 1) {
        let arrFilesMsg = [];
        let arrCFMsg = [];
        let arrPSOMsg = [];
        // popup global error message ex. "You are not authorized to access the data." as Admin
        if (res.globalErrorMessageList && res.globalErrorMessageList.length !== 0) {
          //console.log("submitFile() setGlobalErrorStatus", res, res.status);
          setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
              visible: true,
              title: ERROR_MESSAGES.GENERAL_ERROR.title,
              msg: res.globalErrorMessageList,
              showContactHelp: false
            },
            redirect: {
              redirect: false,
              redirectFirst: false,
              path: "",
              data: {}
            }
          });
        }

        let fieldErrors = res.fieldErrors;
        // set field error
        if (fieldErrors && Object.keys(fieldErrors).length !== 0) {
          Object.keys(fieldErrors).map((key) => {
            if (key === "organizationId") {
              fieldErrors[key].errorMessages.map((item) => {
                arrPSOMsg.push(item)
              })
            }

            if (key === "cfVersionId") {
              fieldErrors[key].errorMessages.map((item) => {
                arrCFMsg.push(item)
              })
            }

            if (key === "files") {
              fieldErrors[key].errorMessages.map((item) => {
                arrFilesMsg.push(item)
              })
            }
          })
          // set validation msg
          validation = {
            "organizationId": {
              inValid: arrPSOMsg.length !== 0,
              msg: arrCFMsg
            },
            "cfVersionId": {
              inValid: arrCFMsg.length !== 0,
              msg: arrCFMsg
            },
            "files": {
              inValid: arrFilesMsg.length !== 0,
              msg: arrFilesMsg
            }
          }
          setValidationMsg(validation);
        }
        setIsInvalid(true);
      } else {
        setIsInvalid(false);
        handleFilesClean();
        refreshDataTable(true);
        setGlobalSuccessStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: "Success!",
            msg: res.message,
            showContactHelp: false
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          }
        });
        setTimeout(function () {
          refreshDataTable(false);
        }, 1000);
      }
    }).catch((error) => {
      setIsInvalid(true);
      //console.log("submitFiles()", error);
      if (error.response.status == 413) {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.GENERAL_ERROR.title,
            msg: "The files submitted exceed the maximum file size allowed.",
            showContactHelp: false
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      } else {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.GENERAL_ERROR.title,
            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
            showContactHelp: false
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      }
    });
  }

  // File upload
  const handleFilesUpload = async () => {

    let validation = {};

    if (psoSelectRef?.current?.value === "0") {
      let arrPSO = [];
      arrPSO.push("PSO is required.");
      validation = {
        ...validation,
        "organizationId": {
          inValid: true,
          msg: arrPSO
        }
      };
    }

    if (cfSelectRef.current.value === "0") {
      let arr = [];
      arr.push("Common Formats Version is required.");
      validation = {
        ...validation,
        "cfVersionId": {
          inValid: true,
          msg: arr
        }
      };
    }

    if (!(files && files.length !== 0)) {
      let arrFilesMsg = [];
      arrFilesMsg.push("Please select the file(s).");
      validation = {
        ...validation,
        "files": {
          inValid: true,
          msg: arrFilesMsg
        }
      };
    }

    // validate file extension and length
    if (files && files.length !== 0) {
      let arrFilesMsg = [];
      files.map(file => {
        const ext = file.name.split(".").pop();
        // XML CSV ZIP
        if (!fileFormat.includes(ext)) {
          arrFilesMsg.push("The file selected \"" + file.name + "\" is not an XML, CSV or ZIP file.")
        }
        // The file name "{0}" must not exceed 45 characters in length.
        if (file.name.length > 45) {
          arrFilesMsg.push("The file name \"" + file.name + "\" must not exceed 45 characters in length.");
        }
      });

      if (arrFilesMsg && arrFilesMsg.length !== 0) {
        validation = {
          ...validation,
          "files": {
            inValid: true,
            msg: arrFilesMsg
          }
        };
      }
    }

    setValidationMsg(validation);

    if (Object.keys(validation).length === 0) {
      let formData = new FormData()
      formData.append("info", "Alt files upload");
      files.map(file =>
        formData.append("files", file)
      )

      formData.append("modelJson", JSON.stringify(modelJson));
      submitFiles(formData, validation);
    }
  }

  // Remove from the file table
  const handleFileRemove = (fileName) => {
    const fileList = files.filter((file) => file.name !== fileName);

    setFiles(fileList);

    let validation = {};

    if (validationMsg.cfVersionId) {
      validation = { "cfVersionId": validationMsg.cfVersionId };
    }

    if (validationMsg.organizationId) {
      validation = {
        ...validation,
        "organizationId": validationMsg.organizationId
      };
    }

    setValidationMsg(validation);
  }

  // Button clean
  const handleFilesClean = () => {
    setIsInvalid(false);
    setProgress(null);
    setValidationMsg({});
    setFiles([]);

    fileInputRef.current.value = "";
    cfSelectRef.current.value = "0";

    if (psoSelectRef && psoSelectRef.current) {
      psoSelectRef.current.value = "0";
    }
  }

  // select common format 
  const handleCFChange = (e) => {

    // "0": "Please Select"
    if (e.target.value === "0") {
      return;
    }

    let validation = {};

    if (validationMsg.files) {
      validation = { "files": validationMsg.files };
    }

    if (validationMsg.organizationId) {
      validation = { "organizationId": validationMsg.organizationId };
    }

    const dtoJson = {
      ...modelJson,
      isTestSubmission: isTestSubmission,
      cfVersionId: e.target.value,
    };

    setModelJson(dtoJson);
    setValidationMsg(validation);
  }

  const handlePSOChange = (e) => {

    // "0": "Please Select"
    if (e.target.value === "0") {
      return;
    }

    let validation = {};

    if (validationMsg.files) {
      validation = { "files": validationMsg.files };
    }

    if (validationMsg.cfVersionId) {
      validation = { "cfVersionId": validationMsg.cfVersionId };
    }

    const dtoJson = {
      ...modelJson,
      isTestSubmission: isTestSubmission,
      organizationId: e.target.value,
    };

    setModelJson(dtoJson);
    setValidationMsg(validation);
  }

  return (
    <div>
      <Row>
        <Col xs={12} xl={7}>
          <Form noValidate>
            <Form.Group as={Col} className="mb-3 text-start" controlId="psoOrgId">
              {initData?.vendorUser && initData.vendorUser === true ?
                <>
                  <Form.Label>Select PSO</Form.Label>
                  <Form.Select
                    name="psoId"
                    onChange={handlePSOChange}
                    ref={psoSelectRef}
                    isInvalid={validationMsg.organizationId?.inValid}
                  >
                    <option value="0">Please Select</option>
                    {
                      initData?.psoList?.map((item) =>
                        <option key={item.id} value={item.id}>{item.name} &#40;{item.psoId}&#41;</option>
                      )}
                  </Form.Select>
                </>
                : null
              }
              <Form.Control.Feedback type="invalid" className="fieldErrorMsg">
                {validationMsg.organizationId?.msg.map((item, index) =>
                  <Stack key={"errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                    <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                    <div>{item}</div>
                  </Stack>)}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} className="mb-3 text-start" controlId="cfVersionId">
              <Form.Label>Select Common Formats Version</Form.Label>
              <Form.Select
                name="cfVersionId"
                onChange={handleCFChange}
                ref={cfSelectRef}
                isInvalid={validationMsg.cfVersionId?.inValid}
              >
                <option value="0">Please Select</option>
                {
                  initData?.cfVersionList?.map((item) =>
                    <option key={item.id} value={item.id}>{item.timePrdCd}</option>
                  )}
              </Form.Select>
              <Form.Control.Feedback type="invalid" className="fieldErrorMsg">
                {validationMsg.cfVersionId?.msg.map((item, index) =>
                  <Stack key={"errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                    <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                    <div>{item}</div>
                  </Stack>)}
              </Form.Control.Feedback>
            </Form.Group>
            <br />
            <Form.Group controlId="files" className="mb-3 text-start">
              <Form.Label>Select File to Submit</Form.Label>
              <Form.Control type="file"
                name="files"
                accept={fileFormat}
                ref={fileInputRef}
                onChange={handleFilesChange}
                isInvalid={validationMsg.files?.inValid}
                className="mb-3"
                title=""
                disabled={files?.length === 1}
              />
              {/*fileInputRef!=null ? fileInputRef.current.validity.valid : "false"*/}
              {progress != null && progress <= 100 ?
                <ProgressBar className={isInvalid ? "mb-3 error" : "mb-3"} now={progress} /*label={`${progress}%`}*/ />
                : null
              }
              <FileList
                title="Selected Files"
                files={files}
                removeAction={handleFileRemove}
              >
              </FileList>
              <Form.Control.Feedback type="invalid" className="fieldErrorMsg">
                <div>
                  {validationMsg.files
                    ? validationMsg.files.msg.map((errorText, index) =>
                      <Stack key={"errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                        <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                        <div>{errorText}</div>
                      </Stack>
                    )
                    : null
                  }
                </div>
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Col>
      </Row>
      <Stack className="pt-3 mb-5" direction="horizontal" gap={3}>
        {/* Submit Button */}
        <TextButton
          variant="normal"
          onClick={handleFilesUpload}
          content={"Submit"}
        >
        </TextButton>
        {/* Cancel Button */}
        <TextButton
          variant="outline"
          onClick={handleFilesClean}
          content={"Cancel"}
        >
        </TextButton>
      </Stack>
    </div>
  )
}

export default AltFileUpload;